var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPanels3Directions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "244px",
    height: "200px",
    viewBox: "0 0 244 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 38 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-connect---solar-help-modals",
    transform: "translate(-769, -610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy",
    transform: "translate(769, 610)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D7CEE0",
    x: 0,
    y: 0,
    width: 244,
    height: 200
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#584380",
    x: 0,
    y: 0,
    width: 244,
    height: 100
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    fill: "#B09FCA",
    points: "2.37785227e-12 -1.97696894e-13 106.546667 100 1.10844667e-12 197"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy",
    fill: "#B09FCA",
    transform: "translate(190.7267, 98.5) scale(-1, 1) translate(-190.7267, -98.5)",
    points: "137.453333 -1.97696894e-13 244 100 137.453333 197"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 113,
    y: 107,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 113,
    y: 136,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 133,
    y: 136,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 93,
    y: 136,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 113,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 133,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-26",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 153,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-27",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 173,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 93,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 73,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    x: 53,
    y: 165,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(53.2617, 98.1211) rotate(-270) translate(-53.2617, -98.1211)",
    x: 43.7617187,
    y: 84.1210937,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(24.2617, 98.1211) rotate(-270) translate(-24.2617, -98.1211)",
    x: 14.7617187,
    y: 84.1210937,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(24.2617, 118.1211) rotate(-270) translate(-24.2617, -118.1211)",
    x: 14.7617187,
    y: 104.121094,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(24.2617, 78.1211) rotate(-270) translate(-24.2617, -78.1211)",
    x: 14.7617187,
    y: 64.1210937,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(192.2617, 98.1211) scale(-1, 1) rotate(-270) translate(-192.2617, -98.1211)",
    x: 182.761719,
    y: 84.1210937,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(221.2617, 98.1211) scale(-1, 1) rotate(-270) translate(-221.2617, -98.1211)",
    x: 211.761719,
    y: 84.1210937,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(221.2617, 118.1211) scale(-1, 1) rotate(-270) translate(-221.2617, -118.1211)",
    x: 211.761719,
    y: 104.121094,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(221.2617, 78.1211) scale(-1, 1) rotate(-270) translate(-221.2617, -78.1211)",
    x: 211.761719,
    y: 64.1210937,
    width: 19,
    height: 28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanels3Directions);
export default __webpack_public_path__ + "static/media/solar-panels-3-directions.672889a3724e837e5b54d70f7f8ab107.svg";
export { ForwardRef as ReactComponent };